import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import type { ReactNode } from 'react';

import '../Cells.scss';

type RowTitleCellProps = {
  value: string;
  description?: string;
  withTooltip?: boolean;
  tooltipTitle?: ReactNode;
};

export const RowTitleCell = ({
  value,
  description,
  withTooltip = false,
  tooltipTitle,
}: RowTitleCellProps) => {
  const renderWithIcon = () => (
    <div className="with-icon">
      <div>{value}</div>
      <Tooltip
        placement="top"
        overlayClassName="row-title-cell-tooltip"
        title={tooltipTitle}
      >
        <InfoCircleOutlined />
      </Tooltip>
    </div>
  );

  return (
    <div className="row-title-cell">
      {withTooltip ? renderWithIcon() : value}
      {description && <span className="description">{description}</span>}
    </div>
  );
};
